import { DEV_BASE_URL } from "../constants";
import api from './api';

export async function getContent(page) {
    try {
        let url = DEV_BASE_URL + "get_homepage/?page="+page.toString()
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        console.error('There was an error fetching the data:', error);
        throw error;
    }
}